/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Logical operator to combine two or more SearchCriteria.<\/p>
 **/
export var CompositeSearchCriteriaOperator;
(function (CompositeSearchCriteriaOperator) {
    CompositeSearchCriteriaOperator["AND"] = "AND";
    CompositeSearchCriteriaOperator["OR"] = "OR";
})(CompositeSearchCriteriaOperator || (CompositeSearchCriteriaOperator = {}));
